export const isRebillyControllerReady = (rebillyInstance) =>
  Boolean(rebillyInstance?._$controllerFrame$_);
